import { render } from "./CompanyProfileHeader.vue?vue&type=template&id=5367ea66&scoped=true"
import script from "./CompanyProfileHeader.vue?vue&type=script&lang=js"
export * from "./CompanyProfileHeader.vue?vue&type=script&lang=js"

import "./CompanyProfileHeader.vue?vue&type=style&index=0&id=5367ea66&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5367ea66"]])

export default __exports__